import * as tslib_1 from "tslib";
import React, { useContext } from 'react';
import { TooltipManager, TooltipPopper } from '../../../Tooltip';
import { MobileContext } from '../../../Context';
import { usePopoverOrTooltip } from './usePopoverOrTooltip';
export var PopoverWithTooltip = function (_a) {
    var children = _a.children, tooltip = _a.tooltip, renderPopover = _a.renderPopover, wrapperClassName = _a.wrapperClassName, allowMobile = _a.allowMobile, popoverProps = tslib_1.__rest(_a, ["children", "tooltip", "renderPopover", "wrapperClassName", "allowMobile"]);
    var isMobile = useContext(MobileContext);
    var _b = usePopoverOrTooltip(!!renderPopover, !!tooltip), showTooltip = _b.showTooltip, onClose = _b.onClose, onMouseEnter = _b.onMouseEnter, onMouseLeave = _b.onMouseLeave, onReferenceClick = _b.onReferenceClick;
    if ((isMobile && !allowMobile) || // mobile is explicitly opt-in
        (isMobile && !renderPopover) || // on mobile, we only care for the popover
        (!tooltip && !renderPopover) || // need at least something to render
        !children) {
        return React.createElement("span", { className: wrapperClassName }, children);
    }
    var popperProps = showTooltip === 'tooltip'
        ? {
            oneLine: true,
            isOpen: true,
        }
        : tslib_1.__assign({}, popoverProps, { isOpen: showTooltip === 'popover', onClickOutside: onClose });
    return (React.createElement("span", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: wrapperClassName },
        React.createElement(TooltipManager, { renderReference: function (_a) {
                var ref = _a.ref;
                return (
                // inline style because popper's measurements need it
                React.createElement("span", { ref: ref, onClick: onReferenceClick, style: { display: 'inline-block' } }, children));
            } },
            React.createElement(TooltipPopper, tslib_1.__assign({}, popperProps, { renderTooltipContent: function (_a) {
                    var scheduleUpdate = _a.scheduleUpdate;
                    if (renderPopover && showTooltip === 'popover') {
                        return renderPopover({
                            scheduleTooltipUpdate: scheduleUpdate,
                            closeTooltip: onClose,
                        });
                    }
                    return tooltip;
                }, usePortal: showTooltip === 'tooltip' })))));
};
PopoverWithTooltip.displayName = 'PopoverWithTooltip';
export default PopoverWithTooltip;
//# sourceMappingURL=PopoverWithTooltip.js.map